
import { FC } from 'react';
import Logo from '../base/Logo';

const Footer: FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <Logo className="text-white" />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              30년 경력의 호텔 셰프가 운영하는 프리미엄 한식 전문점입니다. 
              최상급 이베리코 흑돼지와 정성스러운 한식으로 특별한 식사 경험을 선사합니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-kakao-talk-fill"></i>
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">연락처</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-red-500 mr-3"></i>
                <span className="text-gray-300 text-sm">
                  서울 관악구 봉천동 1625-17
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-red-500 mr-3"></i>
                <span className="text-gray-300 text-sm">02-883-8150</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-red-500 mr-3"></i>
                <span className="text-gray-300 text-sm">
                  평일 11:00~23:00
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-subway-line text-red-500 mr-3"></i>
                <span className="text-gray-300 text-sm">
                  서울대입구역, 낙성대역
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 815광복점. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors mt-4 md:mt-0 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
